@import "../../../../../../shared/styles/base";
@import "../../../../../../shared/components/design-system/Button/styles/surfaces";

.ChartSelectionPanel {
  display: grid;
  @include button-group;

  grid-template-columns: repeat(3, 1fr) repeat(2, auto);
  gap: 1rem;

  &__filterButton {
    margin: auto 0 0.1rem;
  }

  &__groupButton {
    margin: auto 0 0.1rem;
  }

  &__filterChips {
    grid-area: 2 / 1 / 3 / 6;
  }

  &__dateRangePicker {
    width: 100%;
  }

  @media (max-width: 70rem) {
    grid-template-columns: repeat(2, 1fr) auto;
    grid-template-rows: repeat(3, auto);

    &__segmentBy {
      grid-area: 2 / 1 / 3 / 2;
    }

    &__groupButton {
      grid-area: 2 / 3 / 2 / 4;
    }

    &__filterChips {
      grid-area: 3 / 1 / 4 / 4;
    }
  }

  @media (max-width: 40rem) {
    grid-template-columns: 1fr auto auto;
    grid-template-rows: repeat(5, auto);

    &__analysisCode {
      grid-area: 1 / 1 / 2 / 4;
    }

    &__segmentBy {
      grid-area: 2 / 1 / 3 / 4;
    }

    &__dateRange {
      grid-area: 3 / 1 / 4 / 4;
    }

    &__filterButton {
      grid-area: 4 / 3 / 5 / 4;
    }

    &__groupButton {
      grid-area: 4 / 2 / 5 / 3;
    }

    &__filterChips {
      grid-area: 5 / 1 / 6 / 4;
    }
  }
}

.GroupHeader {
  position: relative;
  z-index: 1;
}

.GroupMembers {
  margin-left: 2rem;

  > * {
    position: relative;

    &::before {
      content: "";
      border: 2px dotted $ds-neutral-300;
      border-width: 0 0 2px 2px;
      width: 1rem;
      height: calc(100% + 0.5rem);
      position: absolute;
      left: -1rem;
      top: -1.5rem;
    }
  }
}

.CheckboxItem {
  position: relative;
  border: 1px solid $ds-neutral-200;
  min-height: 2.5rem;
  border-radius: 0.25rem;
  color: $text;
  background-color: $white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  font-size: $ds-font-size-b1;
  box-shadow: $input-inset-shadow;
  margin: 0.5rem 0;
  padding: 0.7rem 1rem;
  gap: 0.5rem;
  line-height: 1;

  &__actionButton {
    margin: -0.25rem;
  }

  &__checkbox,
  &__label {
    width: 3rem;
    flex: 1;
  }

  &__checkbox,
  c-checkbox__label {
    padding: 0.75rem 0 0.75rem 0.75rem;
    margin: -0.75rem 0 -0.75rem -1rem;
  }

  &__actions {
    margin: 0 -0.25rem 0 0;
    width: 2rem;
    padding-left: 1rem;
  }
}
